<template>
  <div>

    <vs-table v-model="SelectedOnboarding" :data="Onboardings">
      <template slot="thead">
        <vs-th>Onboarding</vs-th>
        <vs-th>Description</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].name" style="vertical-align:top">
            {{data[indextr].name}}
            <template slot="edit">
              <vs-input v-model="tr.name" class="inputx" placeholder="Name" />
            </template>
          </vs-td>

          <vs-td :data="data[indextr].description">
            {{data[indextr].description}}
          </vs-td>
          <vs-td>

          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>
            <vs-input v-model="NewOnboarding.name">

            </vs-input>
          </vs-td>
          <vs-td>
            <vs-input v-model="NewOnboarding.description">

            </vs-input>
          </vs-td>
          <vs-td>
            <vs-button @click="addNewOnboarding">Add</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div style="position:absolute; bottom:0px;">
      <vs-button size="small"
                 class="mr-3 bg-success" @click="Save">
        Save
      </vs-button>
    </div>
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';

  export default {
    name: "OnboardingEditor",
    data() {
      return {
        SelectedOnboarding: null,
        NewOnboarding: {}
      };
    },
    mounted() {

    },
    methods: {
      Save() {
        this.$emit("OnboardingChanged",
          {
            Onboarding: this.SelectedOnboarding
          })
      },
      addNewOnboarding() {
        var req = JSON.stringify({

          // TODO: If we have PMF - properly parametrize this to use variables instead string interpolations / replace.
          query: `mutation {
            AddOnboarding(
                entity: {
                    id: 0,
                    name:"${this.NewOnboarding.name.replace(/"/g, '\\"')}"
                    description:"${this.NewOnboarding.description.replace(/"/g, '\\"')}"
                }
            ) {
                id
                title,
                description
            }
        }`});

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            alert('Great job, thanks!');
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      }
    },
    props: ["Onboardings"],
    components: {}
  }
</script>

<style>

  .btn {
    background: none;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    margin-left: 5px;
  }

  .btn-danger {
    background-color: indianred;
    border: 1px solid indianred;
    color: white;
  }

  .btn-success {
    background-color: #349539;
    border: 1px solid #349539;
    color: white;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border: 0px solid white;
  }

  th, td {
    border-bottom: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    vertical-align: bottom;
    max-width: 50px !important;
    width: 50px !important;
  }

    th.skill-name-cell, td.skill-name-cell {
      max-width: unset !important;
      width: unset !important;
    }

  th {
    vertical-align: top;
    font-weight: bold;
  }

  .employee-header div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .employee-header span {
    transform: rotate(-90deg);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*margin-bottom: 40px;*/
    font-weight: 900;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-bottom: 5px;
    /*margin-top: 20px;*/
    margin-left: 0px;
    display: block;
    /*border: 5px solid green;*/
    margin-right: 5px;
  }

  h1 {
    font-weight: 900;
    /*margin-top: 2em;*/
  }

  .completed {
    border: 5px solid green;
  }

  .in-progress {
    border: 5px solid orange;
  }

  .not-started {
    border: 5px solid gray;
  }

  .add-div {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    border: 1px solid green;
    color: green;
    padding-top: 2px;
    padding-left: 1px;
    cursor: pointer;
    font-size: 2em;
    font-weight: 100;
  }

  .skill-cell {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

    .skill-cell.current {
      animation: blink 2s infinite; /* Run the animation indefinitely with a duration of 2 seconds */
    }

  tr.faded {
    /*opacity:0.3;*/
    display: none;
  }

  @keyframes blink {
    0%, 100% {
      opacity: 1; /* Fully visible at the start and end */
    }

    50% {
      opacity: 0; /* Fully invisible in the middle */
    }
  }


  .accordion {
    width: 100%;
  }

  .accordion-item {
    border-bottom: 1px solid #ccc;
  }

  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 10px;
  }

  .employee-icons {
    display: flex;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .add-icon {
    font-size: 24px;
    font-weight: bold;
  }

  .accordion-content {
    display: none;
    padding: 10px;
    background-color: #f9f9f9;
  }

  .status-dot {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
  }

  .skill-status {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
  }
</style>
